import { makeStyles } from '@material-ui/core';

// Golden Hippo wordmark — shown in the expanded sidebar. Drawn inline as SVG text
// (no external font/asset dependency): "Golden" in brand gold, "Hippo" in white,
// which reads well on Backstage's dark sidebar. Swap in the official brand vector
// here when available.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const GOLD = '#edbf26';
const LIGHT = '#FFFFFF';

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 38"
      role="img"
      aria-label="Golden Hippo"
    >
      <text
        x="0"
        y="28"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontSize="28"
        fontWeight="700"
        letterSpacing="0.2"
      >
        <tspan fill={GOLD}>Golden</tspan>
        <tspan fill={LIGHT} dx="8">
          Hippo
        </tspan>
      </text>
    </svg>
  );
};
